export default __webpack_public_path__ + "static/media/resourcesRight.7ce55fea.svg";